<script>
    import NavBar from "../components/NavBar.svelte";

    const facesData = [
      {
        id: 1,
        title: 'NEUTRAL',
        lottie: 'red',
        icon: '/emojis/neutral.png',
        label: 'neutral',
      },
      {
        id: 2,
        title: 'SMILE',
        lottie: 'green',
        icon: '/emojis/smile.png',
        label: 'smile',
      },      
      {
        id: 3,
        title: 'SURPRISE',
        lottie: 'blue',
        icon: '/emojis/surprise.png',
        label: 'surprise',
      },
      {
        id: 4,
        title: 'DISGUST',
        lottie: 'pink',
        icon: '/emojis/disgust.png',
        label: 'disgust',
      },
      {
        id: 5,
        title: 'ANGER',
        lottie: 'orange',
        icon: '/emojis/anger.png',
        label: 'anger',
      },
    ];
    let isVisible = undefined;
    const setVisible = id => {
      isVisible = id;
    }
    const letters = 'ABC';
    let ii = 0;
    let letter = letters[ii];
    const inter = setInterval(() => {
      ii++;
      if (ii === letters.length) {
        ii = 0;
      }
      letter = letters[ii];
    }, 1200);
</script>

<div class='faces'>
    <NavBar />
    {#if facesData && facesData.length > 0}
      {#each facesData as {id, icon, title, label}, index}
        <div class={'faces__content'}>
          <div key={ index } class='faces__emojis'>
            <div class='faces__emojis--name'
              on:mouseenter={ () => setVisible(id) }
              on:click={ () => setVisible(id) }
              on:touchstart={ () => setVisible(id) }
            >
              <span class={(isVisible === id ? 'active' : '')}>
                →
              </span>
              <figure>
                <img src={ icon } alt='icons' />
              </figure>
              <h3 class={(isVisible === id ? 'active' : '')}>
                { title }
              </h3>
            </div>
            <div class='faces__Expression'>
              <div>
                {#if !isVisible}
                  <img src={`../faces/${letter}_neutral.jpg`} alt='Portrait' />
                {/if}
                {#if isVisible === id}
                <img src={`../faces/${letter}_${label}.jpg`} alt='Portrait' />
                {/if}
              </div>
            </div>
          </div>
        </div>
      {/each}
    {:else}
      'Loading...'
    {/if}

</div>